import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { PainPointsSection } from './components/PainPointsSection';
import { ComparisonSection } from './components/ComparisonSection';
import { TransformationSection } from './components/TransformationSection';
import { KitContentsSection } from './components/KitContentsSection';
import { PreviewSection } from './components/PreviewSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { ForWhoSection } from './components/ForWhoSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { StickyCTABar } from './components/StickyCTABar';
export function App() {
  return <div className="min-h-screen w-full bg-brand-alt font-sans text-brand-text selection:bg-brand-yellow/40" data-id="element-0" data-mp="3mjzsz5e2v41t">
      <MetaPixel data-id="element-1" data-mp="3rd1all5o5hp3" />
      <AnnouncementBar data-id="element-2" data-mp="3relumgucxi8p" />
      <main data-id="element-3" data-mp="5opiv1o0k3w">
        <HeroSection data-id="element-4" data-mp="67yvnd9206b" />
        <StatsBar data-id="element-5" data-mp="4n725ibkvc5" />
        <PainPointsSection data-id="element-6" data-mp="56qjqnmbrsa" />
        <ComparisonSection data-id="element-7" data-mp="2zl3cxocsjc6w" />
        <TransformationSection data-id="element-8" data-mp="2zlv3gkrj6jqb" />
        <KitContentsSection data-id="element-9" data-mp="2zmwj72jhrued" />
        <PreviewSection data-id="element-10" data-mp="33mouvo46mgny" />
        <InstantAccessSection data-id="element-11" data-mp="33lwxq8uxsavk" />
        <ForWhoSection data-id="element-12" data-mp="33n6yj5t6bx5w" />
        <BonusesSection data-id="element-13" data-mp="33orkw85c49so" />
        <PricingSection data-id="element-14" data-mp="38m1fe27kzbnd" />
        <GuaranteeSection data-id="element-15" data-mp="38kqce4lym7xb" />
        <FAQSection data-id="element-16" data-mp="38kgkgbhctqoz" />
        <FinalCTASection data-id="element-17" data-mp="38o4edbqpof48" />
      </main>
      <Footer data-id="element-18" data-mp="3dl4llpzarnwx" />
      <StickyCTABar data-id="element-19" data-mp="3dlnu6g324zya" />
    </div>;
}